interface AmountLike {
  amount: number;
  precision: number;
  currencyCode?: string | null;
}

/** Precision-aware Amount formatting (fr-FR) — "—" for missing amounts (Vue formatAmount). */
export function formatAmount(amount: AmountLike | null | undefined): string {
  if (!amount) {
    return "—";
  }
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: amount.currencyCode || "EUR",
  }).format(amount.amount / 10 ** amount.precision);
}

/** Parses a French or dotted decimal euro input into cents ("250,50" → 25050); null when invalid. */
export function parseEurosToCents(value: string): number | null {
  const parsed = Number.parseFloat(value.replace(",", "."));
  return Number.isNaN(parsed) ? null : Math.round(parsed * 100);
}
